module.exports = __webpack_public_path__ + "b5d9aa44dd5b186d461d6138d1efa22a.svg";